import { AppBar, Container, Box, Typography, Link, IconButton, } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAppBar = styled(AppBar)(({  }) => ({
    background: '#fff',
    borderBottom: '1px solid #DADADA',
    position: 'relative',
    zIndex: 2,
}));

export const StyledContainer = styled(Container)(({ theme }) => ({
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
}));

export const HeaderBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    minHeight: '74px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
}));

export const LogoLink = styled(Link)(({  }) => ({
    display: 'inline-flex',
}));

export const NotificationIconButton = styled(IconButton)(({ theme }) => ({
    padding: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '48px',
    minHeight: '48px',
    marginRight: theme.spacing(1),
}));

export const UserBox = styled(Box)(({  }) => ({
    display: 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'center',
}));

export const AvatarWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(0.25),
    border: '2px solid #00D689',
    borderRadius: '100px',
}));

export const UserInfoBox = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(1.75),
}));

export const UserNameTypography = styled(Typography)(({  }) => ({
    display: 'block',
    color: '#3F3F44',
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 600,
}));

export const UserRoleTypography = styled(Typography)(({  }) => ({
    display: 'block',
    color: '#3F3F44',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
}));